import React, {Component} from 'react';
import { Tag } from 'antd';

import Loading from "../../commons/Loading";
import ToolBar from "../../commons/ToolBar";
import {hashCode, permissionCheck} from "../../commons/CommonUtils";
import Constant, {LangOptions, NameColors, Permissions, UserRole} from "../../commons/Constants";

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';


class UserListTable extends Component {

    createCustomToolBar = (props) => {
        const isHideAdd = !permissionCheck([Permissions.User.ADD]);
        const {isShowUserDetail, openDetailPage, onFresh} = this.props;

        return (
            <div>
                <div className='buttonFiled' style={{ display: !isShowUserDetail ? 'block' : 'none'}}>
                    <ToolBar onAdd={() => openDetailPage()} isHideAdd={isHideAdd}
                             onFresh={onFresh}/>
                </div>
                <div className='searchFiled' style={{width: isShowUserDetail ? '100%': ''}}>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    nameCellFormat = (cell, row) => {
        const userTitle = (row.fname.charAt(0) + row.lname.charAt(0)).toUpperCase();
        const i = Math.abs(hashCode(row.email) % 5);
        let nowColor = NameColors[i];

        return (
            <a onClick={() => this.props.openDetailPage(row.id)}>
                <div>
                    <div className="avatar-circle-sml"
                         style={{float: "left", "backgroundColor": nowColor}}>
                        <div className="intials">{userTitle}</div>
                    </div>
                    <div style={{display: "inline-block"}}>
                        <div className="userName">{row.fname} {row.lname}</div>
                        <div className="userEmail">{row.email}</div>
                    </div>
                </div>
            </a>
        );
    }

    accountTypeFormat = (cell) => {
        if (cell) {
            return "Enterprise Only"
        }
        return "Enterprise and Local";
    }

    rolesCellFormat = (cell) => {
        if (cell && Array.isArray(cell) && cell.length > 0) {
            return (
                <div>
                    {cell.sort((obj1, obj2) => {
                        return obj1 > obj2;
                    }).map((role, index) => {
                        if(Object.keys(UserRole).indexOf(role) >= 0)
                            return <Tag key={index} style={{cursor: "default !important"}} >{UserRole[role]["label"]}</Tag>;
                        else
                            return "";
                    })}
                </div>
            )
        }
        return "";
    }

    trClassFormat = (row, rowIndex) => {
        if (row.id === this.props.selectedUserId) {
            return "table_selected_row";
        }
    };

    render() {
        const {data, isShowUserDetail, status, maxHeight} = this.props;
        const options = {
            defaultSortName: 'fname',
            defaultSortOrder: 'asc',
            toolBar: this.createCustomToolBar,
            noDataText: status === Constant.STATUS.trying ? <Loading /> : <div>No user found.</div>,
            searchDelayTime: 500
        }

        return (
            <div className="userTable">
                <BootstrapTable data={ data } search={ true } options={ options } multiColumnSearch={ true }
                                maxHeight={ maxHeight } bodyStyle={{ overflowX: 'hidden' }}
                                trClassName={this.trClassFormat} striped hover condensed>
                    <TableHeaderColumn dataField='id' isKey dataSort={ true } hidden={ true }
                                       searchable={false}>HIDDEN_ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='fname' dataFormat={this.nameCellFormat} dataSort={ true }
                                       width="20%">User Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='lname' hidden={ true }>Last Name for Search</TableHeaderColumn>
                    <TableHeaderColumn dataField='email' hidden={ true }>Email for Search</TableHeaderColumn>
                    <TableHeaderColumn dataField='locale' searchable={false} hidden={isShowUserDetail}
                                       dataFormat={(cell, row, enumObject) => {return (cell && enumObject[cell]) ? enumObject[cell]["label"] : "";}}
                                       formatExtraData={LangOptions} >User Language</TableHeaderColumn>
                    <TableHeaderColumn dataField='allowEnterpriseOnly' hidden={isShowUserDetail}
                                       filterFormatted={true} dataFormat={this.accountTypeFormat}>Sign In Account</TableHeaderColumn>
                    <TableHeaderColumn dataField='roles' width="45%" hidden={isShowUserDetail}
                                       dataFormat={this.rolesCellFormat}>User Role</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

export default UserListTable;


// WEBPACK FOOTER //
// ./src/modules/user/UserListTable.js